import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {cloneDeep} from 'lodash';

@Pipe({
    name: 'decimalToTime'
})
export class ConvertDecimalToTimePipe implements PipeTransform {

    public constructor(
        protected translate: TranslateService
    ) {

    }

    public transform(value: string|number): string {
        return this.doTransform(value);
    }

    protected doTransform(value, hoursPerDay: number = 24): string {
        if (typeof value === 'string') {
            value = +cloneDeep(value);
        }

        const minutesPerDay = hoursPerDay * 60,
            totalMinutes = Math.round(Math.abs(value) * 60),
            days = Math.floor(totalMinutes / minutesPerDay),
            hours = Math.floor((totalMinutes % minutesPerDay) / 60),
            minutes = totalMinutes % 60;

        let ret = '';

        if (days > 0) {
            ret += `${days}${this.translate.instant('TIME.DAYS')} `;
        }

        if (hours > 0) {
            ret += `${hours}${this.translate.instant('TIME.HOURS')} `;
        }

        if (minutes > 0) {
            ret += `${minutes}${this.translate.instant('TIME.MINUTES')}`;
        }

        if (!ret) {
            return `0 ${this.translate.instant('TIME.MINUTES')}`;
        }

        const negative = +value >= 0 ? '' : '-';

        return `${negative}${ret}`;
    }
}
